// node_modules
import { FC, useContext } from "react";
// Contexts
import { TopicModellingSearchContext } from "Providers";
// Types
import { TModelledTopicDTO } from "Types";
// Components
import { FindestButton } from "Components/Shared";
// Styles
import styles from "./topicModellingResults.module.scss";

export const TopicModellingResults: FC = () => {
    // Contexts
    const { modelledTopics, setSelectedModelledTopic, selectedModelledTopic, setIsTopicModellingSearchStarted } = useContext(TopicModellingSearchContext);

    // Logic
    const modelledTopicOnClickHandler = (modelledTopic: TModelledTopicDTO): void => {
        setSelectedModelledTopic(modelledTopic);
    };

    const convertTopicNameToPrettyFormat = (name: string) => {
        return name.replace(/_/g, ", ");
    };

    const onStartClustering = () => {
        setIsTopicModellingSearchStarted(true);
    };

    // Render
    return (
        <div className={`${styles.scrollbarCustomThin} ${styles.topicModellingResults} ${modelledTopics.length > 0 ? styles.withContent : ""}`}>
            {modelledTopics.length > 0 ? modelledTopics.map((modelledTopic: TModelledTopicDTO, index: number) => {
                const prettyClusterKeywords = convertTopicNameToPrettyFormat(modelledTopic.name);
                return (
                    <div className={`${styles.modelledTopicItem} ${selectedModelledTopic?.name === modelledTopic.name ? styles.selected : "" }`} key={index} onClick={() => modelledTopicOnClickHandler(modelledTopic)}>
                        <div className={styles.modelledTopicItemUpperSection}>
                            {index !== 0 && <div className={styles.clusterTitle}>{`Cluster #${index}`}</div>}
                            <div className={styles.clusterCount}>{modelledTopic.documentIds.length}</div>
                        </div>
                        <div title={prettyClusterKeywords} className={styles.clusterKeywords}>{prettyClusterKeywords}</div>
                    </div>
                );
            }) : <FindestButton title="Start clustering" onClick={onStartClustering} extraClassName={styles.clusterResultsButton}/> 
        }
        </div>
    );
};